import * as React from "react";
import { Link, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuthCard, LoginForm, SocialLogin } from "@/components/auth";
import { useAuth } from "@/hooks/useAuth";
import { trackEvent } from "@/lib/umami";

export function LoginPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation("auth");

  React.useEffect(() => {
    if (user) {
      navigate({ to: "/app" });
    }
  }, [user, navigate]);

  return (
    <AuthCard
      title={t("login.title")}
      description={t("login.subtitle")}
      footer={
        <>
          {t("login.noAccount")}{" "}
          <Link
            to="/signup"
            onClick={() => trackEvent("signup_cta_click", { location: "login" })}
            className="font-medium text-primary hover:underline"
          >
            {t("login.signUp")}
          </Link>
        </>
      }
    >
      <LoginForm onSuccess={() => navigate({ to: "/app" })} />
      <SocialLogin page="login" />
    </AuthCard>
  );
}

export default LoginPage;
